jQuery(document).ready(function ($) {
  // primary nav
  $('.nav-primary').accessibleNav({
    desktop: 1400,
    spans: 'hide',
    level2position: 'vertical-bottom',
    level3position: 'horizontal-right'
  });

  //Nav Functionality - Start
  $('.nav-primary .nav-toggle').click(function () {
    $('.nav-wrapper').toggleClass('open-nav');
    $('header').toggleClass('open-nav');
    $('body').toggleClass('open-nav');
    if ($('.nav-primary .ul1').is(':visible')) {
      $('.nav-toggle .bars').removeClass('hide').addClass('show');
      $('.nav-toggle .close').removeClass('show').addClass('hide');
      $('.nav-primary .ul1').fadeOut('slow');
    } else {
      $('.nav-toggle .bars').removeClass('show').addClass('hide');
      $('.nav-toggle .close').removeClass('hide').addClass('show');
      $('.nav-primary .ul1').fadeIn('slow');
    }
  });

  $('.nav-primary .nav-toggle').on('keypress', function (e) {
    $('.nav-wrapper').toggleClass('open-nav');
    $('header').toggleClass('open-nav');
    $('body').toggleClass('open-nav');
    if (e.which === 13) {
      if ($('.nav-primary .ul1').is(':visible')) {
        $('.nav-toggle .bars').removeClass('hide').addClass('show');
        $('.nav-toggle .close').removeClass('show').addClass('hide');
        $('.nav-primary .ul1').fadeOut('slow');
      } else {
        $('.nav-toggle .bars').removeClass('show').addClass('hide');
        $('.nav-toggle .close').removeClass('hide').addClass('show');
        $('.nav-primary .ul1').fadeIn('slow');
      }
    }
  });

  //Move Mobile version of top links inside mobile menu
  if ($(window).width() <= 640) {
    $('.top-nav.mobile').each(function () {
      $(this).insertAfter($('.nav-primary .ul1 .li1:last-of-type'));
    });
  }

  // search
  $('.search-form > button').click(function (e) {
    e.preventDefault();
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $('.search-form input[type="search"]').val();
    var url = root + terms;
    // console.log(url);
    window.location.href = url;
  });
  $('.search-form input[type="search"]').on('keyup', function (e) {
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $(this).val();
    var url = root + terms;
    // console.log(url);
    if (e.which === 13) {
      window.location.href = url;
    }
  });
  $(".search-form input[type='search']").focusin(function () {
    $('.search-form').addClass('active');
  });
  $(".search-form input[type='search']").focusout(function () {
    $('.search-form').removeClass('active');
  });

  // add class to select on open
  $('select').on('click', function () {
    $(this).toggleClass('open');
  });
  $('label').on('click', function (e) {
    if ($(this).next().is('select')) {
      e.preventDefault();
      $(this).next('select').focus();
    }
  });
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      if ($('select').hasClass('open')) {
        $(this).removeClass('open');
      }
    }
  });
  $(window).on('scroll', function () {
    if ($('select').hasClass('open')) {
      $('select').removeClass('open');
    }
  });

  //Search Toggle - Start
  $('.search-toggle').click(function () {
    $(this).addClass('active');
    $('body').addClass('search-open');
    $('.search-box').fadeIn('slow');
    $('.search-box input').first().focus();
    $('.search-box .close').click(function () {
      $('.search-toggle.active').removeClass('active');
      $('.search-box').fadeOut('slow');
      $('body').removeClass('search-open');
    });
    // find focusable items
    var searchFocusable = $('.search-box span.close, .search-box .search-container a.btn-search, .search-box .search-container input');
    var searchFocusableFirst = searchFocusable.first();
    var searchFocusableLast = searchFocusable.last();
    searchFocusableLast.on('keydown', function (e) {
      if ((e.which === 9 && !e.shiftKey)) {
        e.preventDefault();
        searchFocusableFirst.focus();
      }
    });
    searchFocusableFirst.on('keydown', function (e) {
      if ((e.which === 9 && e.shiftKey)) {
        e.preventDefault();
        searchFocusableLast.focus();
      }
    });
  });

  $('.search-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      $(this).addClass('active');
      $('body').addClass('search-open');
      $('.search-box').fadeIn('slow');
      $('.search-box input').first().focus();
      $('.search-box .close').on('keypress', function (e) {
        if (e.which === 13) {
          $('.search-toggle.active').removeClass('active');
          $('.search-box').fadeOut('slow');
          $('body').removeClass('search-open');
        }
      });
      // find focusable items
      var searchFocusable = $('.search-box span.close, .search-box .search-container a.btn-search, .search-box .search-container input');
      var searchFocusableFirst = searchFocusable.first();
      var searchFocusableLast = searchFocusable.last();
      searchFocusableLast.on('keydown', function (e) {
        if ((e.which === 9 && !e.shiftKey)) {
          e.preventDefault();
          searchFocusableFirst.focus();
        }
      });
      searchFocusableFirst.on('keydown', function (e) {
        if ((e.which === 9 && e.shiftKey)) {
          e.preventDefault();
          searchFocusableLast.focus();
        }
      });
    }
  });
  //Search Toggle - End

  //Init Speedbumps
  var SafeLinks = [
    '[href*=".psbank.net"]',
    '[href^="https://psbank.net"]',
    '[href^="http://psbank.net"]',
    '[href^="http://www.psbank.net"]',
    '[href^="http://APIS-2021.lrsws.co"]',
    '[href^="https://APIS-2021.lrsws.co"]',
    '[href^="https://APIShb.btbanking.com/dbiqp"]',
    '[href^="APIShb.btbanking.com"]',
    "[href*='psbank.myebanking.net']",
    '[class*="email"]',
    '[href^="javascript:"]',
    "[href*='iaf.infinity.com']",
    "[href*='sageworksanalyst.com']",
    "[href*='myaccountaccess.com']",
    "[href*='ichoosepsbank.net']",
    "[href*='secure-loancenter.com']",
    "[href*='mortgage-application.net']",
    "[href*='online1.elancard.com']",
    "[href^='?udt']"
  ];

  initSpeedbump(SafeLinks);

  //Login Toggle
  $('.login').click(function () {
    $(this).toggleClass('active');
    $(document).on('click', function (event) {
      if (!$(event.target).closest(".login.active").length) {
        $('.login.active').removeClass('active');
      }
    });
    $(document).on('keypress', function (e) {
      if (e.which === 13) {
        if (!$(e.target).closest(".login.active").length) {
          $('.login.active').removeClass('active');
        }
      }
    });
  });

  $('.login').on('keypress', function (e) {
    if (e.which === 13) {
      $(this).toggleClass('active');
      $(document).on('click', function (event) {
        if (!$(event.target).closest(".login.active").length) {
          $('.login.active').removeClass('active');
        }
      });
    }
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $('.login.active').removeClass('active');
      }
    });
    $(document).on('keypress', function (e) {
      if (e.which === 13) {
        if (!$(e.target).closest(".login.active").length) {
          $('.login.active').removeClass('active');
        }
      }
    });
  });

  // new Splide('.splide').mount();

  new Splide('.news-items', {
    perPage: 3,
    cover: true,
    arrows: false,
    pagination: false,
    autoHeight: true,
    gap: 50,
    breakpoints: {
      768: {
        perPage: 1,
        pagination: true
      },
      1024: {
        perPage: 2,
        pagination: true
      },
    },
    classes: {
      pagination: 'splide__pagination dots', // container
    },
    // padding: {
    //   left: 0,
    //   right: '60px',
    // }
  }).mount();

  //Antilles Chat
  // $('#antilles-live-chat .c_h').on("click", function () {
  //   $(this).toggleClass('active');
  // });

  // $('#antilles-live-chat .c_h').on('keypress', function (e) {
  //   if (e.which === 13) {
  //     $(this).toggleClass('active');
  //     $('.chat_container').slideToggle('slow');
  //     $('.chat_container a:last').on('focusout', function () {
  //       $('.c_h').focus();
  //     });

  //   }
  // });

});